<template>
  <!-- Sidebar -->
  <div class="sidebar" id="sidebar">
    <perfect-scrollbar
      class="scroll-area"
      :settings="settings"
      @ps-scroll-y="scrollHanle"
    >
      <div class="sidebar-inner slimscroll">
        <div id="sidebar-menu" class="sidebar-menu">
          <ul>
            <li class="clinicdropdown">
              <router-link to="/settings/profile">
                <img
                  src="@/assets/img/profiles/avatar-14.jpg"
                  class="img-fluid"
                  alt="Profile"
                />
                <div class="user-names">
                  <h5>Adrian Davies</h5>
                  <h6>Tech Lead</h6>
                </div>
              </router-link>
            </li>
          </ul>
          <vertical-sidebar></vertical-sidebar>
        </div>
      </div>
    </perfect-scrollbar>
  </div>
  <!-- /Sidebar -->
</template>

<script>
import { PerfectScrollbar } from "vue3-perfect-scrollbar";
import "vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css";
export default {
  components: {
    PerfectScrollbar,
  },
  data() {
    return {
      settings: {
        suppressScrollX: true,
      },
    };
  },
  methods: {
    scrollHanle() {},
  },
};
</script>
